export const LANGUAGE_NL = "nl"
